module.exports = __webpack_public_path__ + "assets/img/workshopPhoto.2b949267.png";